import { gql } from 'apollo-boost';

export const TEST_RESEND_EMAIL = gql`
    mutation TestResendEmail($data: TestResendEmailInput!) {
        testResendEmail(data: $data)
    }
`;

